import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import windbarb from 'highcharts/modules/windbarb';
import more from 'highcharts/highcharts-more';
import exportdata from 'highcharts/modules/export-data';
import accessibility from 'highcharts/modules/accessibility';
import { map, pipe, startWith, switchMap, takeUntil } from 'rxjs';
import { TramDoGiaTriDoService } from 'src/app/thmp-monitoring/services/tram-do-gia-tri-do.service';
import { TramDoYeuToDoService } from 'src/app/thmp-monitoring/services/tram-do-yeu-to-do.service';
import { TramDoService } from 'src/app/thmp-monitoring/services/tram-do.service';
import { SecondPageIndexBase } from 'sv-shared';
import * as XLSX from "xlsx";
import { DatePipe } from '@angular/common';
import * as HighchartsStock from 'highcharts/highstock';

windbarb(Highcharts);
more(Highcharts);
exportdata(Highcharts);
accessibility(Highcharts)

@Component({
  selector: 'app-tramdo-detail',
  templateUrl: './tramdo-detail.component.html',
  styleUrls: ['./tramdo-detail.component.css']
})
export class TramdoDetailComponent extends SecondPageIndexBase implements OnInit {

  @ViewChild('charts') public chartEl: ElementRef;

  Highcharts: typeof Highcharts = Highcharts;
  Highcharts1: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  dataGio = [];
  idTramDo = 0;
  itemDetail = { id: 0, title: '', address: '', gpsLat: '', gpsLong: '' }
  tuNgay: Date;
  denNgay: Date;
  listTramDoYeuToDo = [];
  @ViewChild("tblData") tblData: ElementRef;

  listTramDoYeuToDoKhac = [];
  listChartOptions = [];
  polarChartOptions: Highcharts.Options;


  monthReport = new Date();
  idDmYeuToDo = 0;
  optionDmYeuTodo = [];
  cols1 = [];
  dataSourceMonth = [];
  dataExportMonth = [];

  itemHuongGio: any;
  listTramDo = [];
  selectedItem: any;

  constructor(
    private _tramDoService: TramDoService,
    protected _injector: Injector,
    private _tramDoGiaTriDoService: TramDoGiaTriDoService,
    private _tramDoYeuToDoService: TramDoYeuToDoService,
    private _datepipe: DatePipe
  ) {
    super(null, _injector);
    this.tuNgay = new Date();
    this.tuNgay.setHours(0, 0, 0, 0)
    this.denNgay = new Date();

  }

  ngOnInit() {
    this.cols = [
      { field: 'thoiGianDo', header: this._translateService.instant('FORM.CODE'), visible: true, width: 'auto', },
      { field: 'gioPhutDo', header: this._translateService.instant('FORM.TITLE'), visible: true, width: 'auto', },
    ];

    this.getsMyTramDo();

    this._activatedRoute.params
      .pipe(map(params => params['id']), takeUntil(this._unsubscribeAll))
      .subscribe(async pid => {
        this.idTramDo = pid;

      });
    if (this.idTramDo !== undefined) {
      this.getDetail();
      this.getData();
    }
  }

  getDetail() {
    this._tramDoService.getById(this.idTramDo).then(rs => {
      if (rs.success) {
        this.itemDetail = rs.data;
      }
    });
    this._tramDoYeuToDoService.getsAllByIdTramDo(this.idTramDo).then(rs => {
      if (rs.success) {
        this.listTramDoYeuToDo = rs.data.filter(x => x.checked == true);
        this.listTramDoYeuToDoKhac = rs.data.filter(x => (x.codeDmYeuToDo != 'ff' && x.codeDmYeuToDo != 'dd') && x.checked == true);
        rs.data.forEach(item => {
          this.optionDmYeuTodo.push({ label: `${item.titleDmYeuToDo} (${item.codeDmYeuToDo})`, value: item.idDmYeuToDo })
        });
      }
    });
  }

  getData() {
    let searchModel = {
      idTramDo: this.idTramDo,
      tuNgay: this.tuNgay,
      denNgay: this.denNgay,
    }
    this._tramDoGiaTriDoService.find(searchModel).then(rs => {
      if (rs.success) {
        this.dataSource = rs.data;
        let listThoiGianDo = [];
        // Bind biểu đồ gió
        this.dataGio = [];
        for (let i = 0; i < rs.data.length; i++) {
          let item = rs.data[i];
          listThoiGianDo.push(this._datepipe.transform(new Date(item.thoiGianDo), 'HH:mm'));
          this.dataGio.push([item[28], item[29]]);
        }
        this.chartOptions = {
          title: {
            text: 'Biểu đồ gió tại Trạm đo',
            align: 'left'
          },
          xAxis: {
            categories: listThoiGianDo,
            type: 'datetime',
            offset: 40
          },
          yAxis: {
            title: {
              text: 'Tốc độ gió (m/s)'
            },
          },
          plotOptions: {
            series: {
              animation: {
                duration: 1000
              },
              marker: {
                enabled: false
              },
              lineWidth: 2
            }
          },
          series: [
            {
              type: 'windbarb',
              data: this.dataGio,
              name: 'Hướng gió',
              color: Highcharts.getOptions().colors[1],
              showInLegend: false,
              tooltip: {
                valueSuffix: ' độ'
              }
            },
            {
              type: 'spline',
              keys: ['y'], // wind direction is not used here
              data: this.dataGio,
              color: Highcharts.getOptions().colors[0],
              name: 'Tốc độ gió',
              tooltip: {
                valueSuffix: ' m/s'
              },
              states: {
                inactive: {
                  opacity: 1
                }
              }
            }
          ]
        };

        // Các biểu đồ khác
        this.listChartOptions = [];
        this.listTramDoYeuToDoKhac.forEach(itemYeuToDo => {
          let dataYeuToDo = [];
          this.dataSource.forEach(item => {
            dataYeuToDo.push([item[itemYeuToDo.idDmYeuToDo]]);
          });
          let chartOptions = {
            rangeSelector: {
              selected: 1
            },
            title: {
              text: `Biểu đồ ${itemYeuToDo.titleDmYeuToDo}`,
              align: 'left'
            },
            xAxis: {
              categories: listThoiGianDo
            },
            yAxis: {
              title: {
                text: `${itemYeuToDo.donViDo}`
              }
            },
            plotOptions: {
              series: {
                animation: {
                  duration: 1000
                },
                marker: {
                  enabled: false
                },
                lineWidth: 2
              }
            },
            series: [
              {
                type: itemYeuToDo.codeDmYeuToDo == 'H' ? 'area' : 'spline',
                keys: ['y'],
                data: dataYeuToDo,
                color: Highcharts.getOptions().colors[0],
                name: `${itemYeuToDo.titleDmYeuToDo}`,
                tooltip: {
                  valueSuffix: ` ${itemYeuToDo.donViDo}`
                },
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              }
            ]
          };
          this.listChartOptions.push(chartOptions);
        });

        // Hướng gió và tỷ lệ gió
        let count = rs.data.length;
        let polarValue = rs.data[count - 1][29];
        let tocDoGio = rs.data[count - 1][28];
        let dataPolar = [];

        this.itemHuongGio = { giaTri: rs.data[count - 1][29] };

        let colorStr = 'rgb(44, 175, 254)';
        if (tocDoGio >= 0.5 && tocDoGio < 2) {
          colorStr = 'rgb(84, 79, 197)'
        }
        else if (tocDoGio >= 2 && tocDoGio < 4) {
          colorStr = 'rgb(0, 226, 114)'
        }
        else if (tocDoGio >= 4 && tocDoGio < 6) {
          colorStr = 'rgb(254, 106, 53)'
        }
        else if (tocDoGio >= 6 && tocDoGio < 8) {
          colorStr = 'rgb(107, 138, 188)'
        }
        else if (tocDoGio >= 8 && tocDoGio < 10) {
          colorStr = 'rgb(213, 104, 251)'
        }
        else if (tocDoGio >= 10) {
          colorStr = 'rgb(46, 224, 202)'
        }

        if (polarValue < 12) {
          dataPolar = [tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (12 <= polarValue && polarValue < 34) {
          dataPolar = [0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (34 <= polarValue && polarValue < 57) {
          dataPolar = [0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (57 <= polarValue && polarValue < 79) {
          dataPolar = [0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (79 <= polarValue && polarValue < 102) {
          dataPolar = [0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (102 <= polarValue && polarValue < 124) {
          dataPolar = [0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (124 <= polarValue && polarValue < 147) {
          dataPolar = [0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (147 <= polarValue && polarValue < 169) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (169 <= polarValue && polarValue < 192) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0]
        }
        else if (192 <= polarValue && polarValue < 214) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0]
        }
        else if (214 <= polarValue && polarValue < 237) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0]
        }
        else if (237 <= polarValue && polarValue < 259) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0]
        }
        else if (259 <= polarValue && polarValue < 282) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0]
        }
        else if (282 <= polarValue && polarValue < 304) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0]
        }
        else if (304 <= polarValue && polarValue < 327) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0]
        }
        else if (327 <= polarValue && polarValue < 349) {
          dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio]
        }
        else if (polarValue >= 349) {
          dataPolar = [tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }



        this.polarChartOptions = {
          chart: { polar: true, type: 'column' },
          title: { text: 'BIỂU ĐỒ HƯỚNG GIÓ' },
          subtitle: { text: null },
          pane: { size: '80%' },
          legend: { align: 'left', verticalAlign: 'top', y: 50, layout: 'vertical', enabled: false },
          xAxis: {
            tickmarkPlacement: 'on'
            , categories: ["B", "BĐB", "ĐB", "ĐĐB", "Đ", "ĐĐN", "ĐN", "NĐN", "N", "NTN", "TN", "TTN", "T", "TTB", "TB", "BTB"]
          },
          yAxis: {
            min: 0, endOnTick: false, showLastLabel: false, title: { text: '' },
            // labels: {
            //   formatter: function () {
            //     return `${polarValue} độ`;
            //   },

            // },
            reversedStacks: false
          },
          tooltip: { valueSuffix: ' m/s' },
          plotOptions: {
            series: {
              stacking: 'normal',
              shadow: false,
              pointPlacement: 'on'
            }
          },
          series: [
            {
              type: 'column',
              name: '',
              data: dataPolar
            }
          ],
          colors: [colorStr
          ]
        }
      }
    });
  }

  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tblData.nativeElement
    );

    /* new format */
    var fmt = "0.00";
    /* change cell format of range B2:D4 */
    var range = { s: { r: 1, c: 1 }, e: { r: 2, c: 100000 } };
    for (var R = range.s.r; R <= range.e.r; ++R) {
      for (var C = range.s.c; C <= range.e.c; ++C) {
        var cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
        if (!cell || cell.t != "n") continue; // only format numeric cells
        cell.z = fmt;
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    var fmt = "@";
    wb.Sheets["Sheet1"]["F"] = fmt;

    /* save to file */
    XLSX.writeFile(wb, "SoLieuDo.xlsx");
  }

  myCustomOperator() {
    return pipe(
      startWith(""),
      switchMap(async () => this.getData())
    );
  }

  goReport() {
    this._router.navigate([`/baocao/${this.idTramDo}`]);
  }


  getDataMonth() {
    if (!this.monthReport) {
      this._notifierService.showWarning('Bạn chưa chọn tháng');
      return;
    }
    if (!this.idDmYeuToDo) {
      this._notifierService.showWarning('Bạn chưa chọn yếu tố đo');
      return;
    }
    var model = {
      idTramDo: this.idTramDo,
      idDmYeuToDo: this.idDmYeuToDo,
      monthReport: this.monthReport
    };
    var yeuToDoInfo = this.listTramDoYeuToDo.filter(x => x.idDmYeuToDo == this.idDmYeuToDo)[0];
    if (yeuToDoInfo.tinhTongGiaTriDoTrong60p) {
      this.cols1 = [
        { field: 'thoiGianDo', header: 'Ngày', visible: true, width: '100px', },
        { field: 'h0', header: '01h', visible: true, width: 'auto', },
        { field: 'h1', header: '02h', visible: true, width: 'auto', },
        { field: 'h2', header: '03h', visible: true, width: 'auto', },
        { field: 'h3', header: '04h', visible: true, width: 'auto', },
        { field: 'h4', header: '05h', visible: true, width: 'auto', },
        { field: 'h5', header: '06h', visible: true, width: 'auto', },
        { field: 'h6', header: '07h', visible: true, width: 'auto', },
        { field: 'h7', header: '08h', visible: true, width: 'auto', },
        { field: 'h8', header: '09h', visible: true, width: 'auto', },
        { field: 'h9', header: '10h', visible: true, width: 'auto', },
        { field: 'h10', header: '11h', visible: true, width: 'auto', },
        { field: 'h11', header: '12h', visible: true, width: 'auto', },
        { field: 'h12', header: '13h', visible: true, width: 'auto', },
        { field: 'h13', header: '14h', visible: true, width: 'auto', },
        { field: 'h14', header: '15h', visible: true, width: 'auto', },
        { field: 'h15', header: '16h', visible: true, width: 'auto', },
        { field: 'h16', header: '17h', visible: true, width: 'auto', },
        { field: 'h17', header: '18h', visible: true, width: 'auto', },
        { field: 'h18', header: '19h', visible: true, width: 'auto', },
        { field: 'h19', header: '20h', visible: true, width: 'auto', },
        { field: 'h20', header: '21h', visible: true, width: 'auto', },
        { field: 'h21', header: '22h', visible: true, width: 'auto', },
        { field: 'h22', header: '23h', visible: true, width: 'auto', },
        { field: 'h23', header: '24h', visible: true, width: 'auto', },
        { field: 'sumValue', header: 'Tổng', visible: true, width: 'auto', },
        { field: 'avgValue', header: 'TB', visible: true, width: 'auto', },
        { field: 'minValue', header: 'Min', visible: true, width: 'auto', },
        { field: 'maxValue', header: 'Max', visible: true, width: 'auto', },

      ];
    } else {
      this.cols1 = [
        { field: 'thoiGianDo', header: 'Ngày', visible: true, width: '100px', },
        { field: 'h0', header: '01h', visible: true, width: 'auto', },
        { field: 'h1', header: '02h', visible: true, width: 'auto', },
        { field: 'h2', header: '03h', visible: true, width: 'auto', },
        { field: 'h3', header: '04h', visible: true, width: 'auto', },
        { field: 'h4', header: '05h', visible: true, width: 'auto', },
        { field: 'h5', header: '06h', visible: true, width: 'auto', },
        { field: 'h6', header: '07h', visible: true, width: 'auto', },
        { field: 'h7', header: '08h', visible: true, width: 'auto', },
        { field: 'h8', header: '09h', visible: true, width: 'auto', },
        { field: 'h9', header: '10h', visible: true, width: 'auto', },
        { field: 'h10', header: '11h', visible: true, width: 'auto', },
        { field: 'h11', header: '12h', visible: true, width: 'auto', },
        { field: 'h12', header: '13h', visible: true, width: 'auto', },
        { field: 'h13', header: '14h', visible: true, width: 'auto', },
        { field: 'h14', header: '15h', visible: true, width: 'auto', },
        { field: 'h15', header: '16h', visible: true, width: 'auto', },
        { field: 'h16', header: '17h', visible: true, width: 'auto', },
        { field: 'h17', header: '18h', visible: true, width: 'auto', },
        { field: 'h18', header: '19h', visible: true, width: 'auto', },
        { field: 'h19', header: '20h', visible: true, width: 'auto', },
        { field: 'h20', header: '21h', visible: true, width: 'auto', },
        { field: 'h21', header: '22h', visible: true, width: 'auto', },
        { field: 'h22', header: '23h', visible: true, width: 'auto', },
        { field: 'h23', header: '24h', visible: true, width: 'auto', },
        { field: 'avgValue', header: 'TB', visible: true, width: 'auto', },
        { field: 'minValue', header: 'Min', visible: true, width: 'auto', },
        { field: 'maxValue', header: 'Max', visible: true, width: 'auto', },

      ];

    }




    this._tramDoGiaTriDoService.getsReportByMonth(model).then(rs => {
      if (rs.success) {
        this.dataSourceMonth = rs.data;
        this.dataExportMonth = rs.data;
      }
    })
  }
  exportExcelMonth() {
    if (!this.monthReport) {
      this._notifierService.showWarning('Bạn chưa chọn tháng');
      return;
    }
    if (!this.idDmYeuToDo) {
      this._notifierService.showWarning('Bạn chưa chọn yếu tố đo');
      return;
    }
    var model = {
      idTramDo: this.idTramDo,
      idDmYeuToDo: this.idDmYeuToDo,
      monthReport: this.monthReport
    };

    this._tramDoGiaTriDoService.exportReportByMonth(model);
  }

  getTextHuongGio(giaTri) {
    if (giaTri < 12) {
      return "hướng bắc";
    }
    else if (12 <= giaTri && giaTri < 34) {
      return "hướng bắc đông bắc";
    }
    else if (34 <= giaTri && giaTri < 57) {
      return "hướng đông bắc";
    }
    else if (57 <= giaTri && giaTri < 79) {
      return "hướng đông đông bắc";
    }
    else if (79 <= giaTri && giaTri < 102) {
      return "hướng đông";
    }
    else if (102 <= giaTri && giaTri < 124) {
      return "hướng đông đông nam";
    }
    else if (124 <= giaTri && giaTri < 147) {
      return "hướng đông nam";
    }
    else if (147 <= giaTri && giaTri < 169) {
      return "hướng nam đông nam";
    }
    else if (169 <= giaTri && giaTri < 192) {
      return "hướng nam";
    }
    else if (192 <= giaTri && giaTri < 214) {
      return "hướng nam tây nam";
    }
    else if (214 <= giaTri && giaTri < 237) {
      return "hướng tây nam";
    }
    else if (237 <= giaTri && giaTri < 259) {
      return "hướng tây tây nam";
    }
    else if (259 <= giaTri && giaTri < 282) {
      return "hướng tây";
    }
    else if (282 <= giaTri && giaTri < 304) {
      return "hướng tây tây bắc";
    }
    else if (304 <= giaTri && giaTri < 327) {
      return "hướng tây bắc";
    }
    else if (327 <= giaTri && giaTri < 349) {
      return "hướng bắc tây bắc";
    }
    else if (giaTri >= 349) {
      return "hướng bắc";
    }
  }


  getsMyTramDo() {
    this.listTramDo = [];
    this._tramDoService.getsMyTramDo().then((res) => {
      if (res.success) {
        this.convertDataToOptions(this.listTramDo, res.data, 'title');
        if (this.idTramDo == undefined) {
          this.idTramDo = res.data[0].id;
          this.getDetail();
          this.getData();
        }
      }
    });
  }

  onChangeTramDo() {
    this.idTramDo = this.selectedItem;
    this.getDetail();
    this.getData();
  }

}
